<template>
  <div :id="chart_id"></div>
</template>


<script>
import Vue from 'vue';
import { mapGetters } from "vuex";
import Highcharts from "highcharts";

export default {
  name: 'FundamentalChart',
  components:{
  },
  props: {
    series: {},
    title: {},
    chart_id: {},
  },
  data: () => ({
  }),
  mounted() {
    this._initHighcharts();
  },
  created: function() {
  },
  computed: {
  },
  methods: {
    _initHighcharts: function () {
      let self = this;
      Vue.nextTick(function() {
        Highcharts.chart(self.chart_id, {
          chart: {
            type: 'line',
            zoomType: 'x',
          },
          title: {
            text: '',
          },
          xAxis: {
            visible: false,
          },
          yAxis: {
            title: '',
            type: 'logarithmic',
          },
          tooltip: {
            shared: true,
            crosshairs: true
          },
          series: [{
            name: self.title,
            data: self.series
          }],
          colors: ['#4572A7', '#a4a5a7'],
        });
      });
    }
  },
}
</script>


<style lang="scss" scoped>
  @import "@/styles/basics/globals.scss";
</style>